import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { BackButton } from '@twa-dev/sdk/react'

import { FlexLayout } from 'layouts'
import { useValueContext } from 'contexts'
import { Button, DatePicker, FormInput, SexButtons } from 'components'
import { formatDateToISO, formatISOToInputDate, isISOValid } from 'utils'

export const EditBaby = observer(() => {
  const navigate = useNavigate()

  const { editableBaby, setEditableBaby, editBaby, loading } = useValueContext()

  const [name, setName] = useState(editableBaby?.name)
  const [birthDate, setBirthDate] = useState(editableBaby?.birthDate)
  const [gender, setGender] = useState(editableBaby?.gender)

  const isFormValid = isISOValid(formatDateToISO(birthDate)) && name

  const handleBirthDateChange = (dateStr: string) => {
    setBirthDate(dateStr)
  }

  const handleSave = () => {
    setEditableBaby({ ...editableBaby, name, birthDate, gender })
    editBaby()
  }

  useEffect(() => {
    if (!editableBaby) navigate('/profile')
  }, [editableBaby, navigate])

  return (
    <>
      <BackButton />
      <FlexLayout.Container className="with-mobile-indent" vertical>
        <div className="page-title">Редактирование ребенка</div>
        <FlexLayout.Content className="scrollable-layout" scrollable>
          <div>Пол</div>
          <SexButtons selected={gender} onChange={setGender} />
          <br />
          <FormInput value={name} label="Имя вашего ребенка" onChange={setName} />
          <br />
          <DatePicker
            label="Дата рождения"
            value={formatISOToInputDate(birthDate)}
            onChange={handleBirthDateChange}
            scrollToOnFocus
          />
        </FlexLayout.Content>
        <div className="event-footer">
          <Button width="100%" disabled={loading || !isFormValid} onClick={handleSave}>
            Сохранить изменения
          </Button>
        </div>
      </FlexLayout.Container>
    </>
  )
})
